import { render } from "./ServiceFileDelta.vue?vue&type=template&id=6dcabd41&scoped=true"
import script from "./ServiceFileDelta.vue?vue&type=script&lang=js"
export * from "./ServiceFileDelta.vue?vue&type=script&lang=js"

import "./ServiceFileDelta.vue?vue&type=style&index=0&id=6dcabd41&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dcabd41"]])

export default __exports__